<script lang="ts">
import { defineComponent } from 'vue';
import { AisPagination } from 'vue-instantsearch/vue3/es';

export default defineComponent({
  components: { AisPagination },
  emits: ['pageChange'],
  data() {
    return {
      pageRangeLimit: 2,
    };
  },
});
</script>
<template>
  <ais-pagination @page-change="$emit('pageChange')">
    <template
      #default="{ currentRefinement, nbPages, pages, isFirstPage, isLastPage, refine, createURL }"
    >
      <ul v-if="nbPages > 1" class="mt-16 flex items-center justify-center gap-x-2.5">
        <!--If we have any previous pages, add the left arrow -->
        <li v-if="!isFirstPage">
          <a
            :href="createURL(currentRefinement - 1)"
            aria-label="Previous page"
            class="grid size-10 place-items-center rounded-full bg-secondary-500"
            @click.exact.prevent="refine(currentRefinement - 1)"
          >
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" aria-hidden="true">
              <path
                d="M20.2383 27.9839L12.4944 20.24L20.2383 12.4962"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
              />
              <path
                d="M12.4923 20.2374L27.3066 20.2374"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
              />
            </svg>
          </a>
        </li>
        <li v-if="currentRefinement + 1 > 1 + pageRangeLimit">
          <a
            :href="createURL(0)"
            aria-label="Page number 1"
            class="grid size-10 place-items-center"
            @click.exact.prevent="refine(0)"
          >
            1
          </a>
        </li>

        <!-- Get the dynamic page range in the middle -->
        <template
          v-for="page in pages.filter(
            (num: number) => Math.abs(num - currentRefinement) < pageRangeLimit,
          )"
          :key="page"
        >
          <li
            v-if="page === currentRefinement"
            class="grid size-10 place-items-center rounded-full bg-primary-200"
            :aria-label="`Page number ${page + 1}`"
            aria-current="page"
          >
            <!-- 0-based -->
            {{ page + 1 }}
          </li>
          <li v-else>
            <a
              :href="createURL(page)"
              :aria-label="`Page number ${page + 1}`"
              class="grid size-10 place-items-center"
              @click.exact.prevent="refine(page)"
            >
              <!-- 0-based -->
              {{ page + 1 }}
            </a>
          </li>
        </template>

        <!-- If we have any additional pages, add the right arrow -->
        <li v-if="!isLastPage">
          <a
            :href="createURL(currentRefinement + 1)"
            aria-label="Next page"
            class="grid size-10 place-items-center rounded-full bg-secondary-500"
            @click.exact.prevent="refine(currentRefinement + 1)"
          >
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" aria-hidden="true">
              <path
                d="M19.7617 12.0161L27.5056 19.76L19.7617 27.5038"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
              />
              <path
                d="M27.5077 19.7626H12.6934"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
              />
            </svg>
          </a>
        </li>
      </ul>
      <!-- Empty as we want no output -->
      <div v-else aria-hidden="true"></div>
    </template>
  </ais-pagination>
</template>
